import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { JWT } from "aws-amplify/auth";
import { jwtDecode } from "jwt-decode";

import axios from "axios";
import { useAuthContext } from "../../hooks/Auth";
import { setToken } from "../../utils/tokenFunctions";
import { Spinner } from "../../components/Loading/Spinner";
import { iLTIUserSchoologyContext } from "../../interfaces/Auth/iLTIUserSchoologyContext";

const baseUrl = process.env.REACT_APP_API_LTI_SCHOOLOGY || "https://api-lti-dev.ummia.ai";

export default function LtiApp() {  
  const [params] = useSearchParams();
  const [err, setErr] = useState<string | null>(null);
  const [enrollmentStatus, setEnrollmentStatus] = useState<string>("PENDING");
  const [pendingMsg, setPendingMsg] = useState<string>("Procesando autenticación y enrolamiento...");
  const token = params.get("idToken");
  const ltiSessionId = params.get("ltiSessionId");  
  const navigate = useNavigate();
  const { loginFromLTI } = useAuthContext();

  // Frases para mostrar mientras está en PENDING
  const pendingMessages = [
    "Procesando autenticación y enrolamiento...",
    "Verificando credenciales...",
    "Confirmando alta en la organización...",
    "Asignando roles en la suscripción...",
    "Casi listo, preparando tu entorno..."
  ];

  // Cambiar mensaje dinámico cada 3s
  useEffect(() => {
    if (enrollmentStatus === "PENDING") {
      let index = 0;
      const interval = setInterval(() => {
        index = (index + 1) % pendingMessages.length;
        setPendingMsg(pendingMessages[index]);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [enrollmentStatus]);

  // Procesar token y empezar polling
  useEffect(() => {
    if (!token) {
      setErr("No se encontró el token");
      return;
    }

    try {
      const decoded: any = jwtDecode(token);

      const wrapped: JWT = {
        payload: {
          ...decoded,
          username: decoded["cognito:username"] || decoded["email"] || decoded["sub"],
        },
      };

      setToken(wrapped);

      console.log("LTI idToken raw:", token);
      console.log("LTI token wrapped:", wrapped);

      // Iniciar polling para enrolamiento
      if (decoded.email) {
        const interval = setInterval(async () => {
          try {
            const res = await axios.get(
              `${baseUrl}/lti/enrollment-status?email=${encodeURIComponent(decoded.email)}`
            );

            console.log("Respuesta de enrolamiento:", JSON.stringify(res));

            const status = res.data?.status || res.data?.body?.status;

            if (!status) {
              setErr("Respuesta inválida del servidor");
              clearInterval(interval);
              return;
            }

            setEnrollmentStatus(status);

            if (status === "FAILED") {
              clearInterval(interval);
              setErr("Falló el proceso de enrolamiento, intenta nuevamente.");
            }

            if (status === "COMPLETED") {
              clearInterval(interval);
              console.log("Enrolamiento completado, refrescando app...");
              const sessionResponse = await axios.get(`${baseUrl}/lti/session/${ltiSessionId}`);
              if(sessionResponse.status !== 200) {
                setErr("No se pudo obtener la sesión LTI del usuario, intenta nuevamente.");
                return;
              }
              
              const ltiContext:iLTIUserSchoologyContext = sessionResponse.data;
              console.log("Contexto LTI obtenido:", ltiContext); 
              localStorage.setItem("ltiContext", JSON.stringify(ltiContext));                           
              loginFromLTI(ltiContext);             
              window.location.href = "/asistente/menu";
            }
          } catch (err) {
            console.error("Error verificando enrolamiento:", err);
          }
        }, 5000);

        return () => clearInterval(interval);
      }
    } catch (error: any) {
      console.error("Error al procesar token LTI:", error);
      setErr("Error al procesar el token LTI");
    }
  }, [token, navigate]);

  // Ejecutar login LTI
  // useEffect(() => {
  //   const storedToken = localStorage.getItem("authToken");
  //   if (storedToken && !isUserAuthenticated && ltiSessionId) {
  //     console.log("Ejecutando loginFromLTI desde app.tsx");
  //     loginFromLTI();
  //   }
  // }, [loginFromLTI, isUserAuthenticated, ltiSessionId]);

  if (err) return <div>Error {err}. Vuelve a lanzar desde Schoology.</div>;

  return <Spinner msg={enrollmentStatus === "PENDING" ? pendingMsg : "Procesando autenticación LTI..."} />;
}
